<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Aanwezigen koffietafel"
      intro="Overzicht van de bevestigde aanwezigheden en afwezigheden voor de koffietafel."
    />

    <!-- Two columns -->
    <v-row
      justify="center"
      class="mb-8 pb-8 koffietafel-columns"
    >
      <!-- Aanwezig -->
      <v-col
        cols="12"
        md="5"
        lg="4"
        class="center px-2"
      >
        <div class="koffietafel-column">
          <div class="koffietafel-column-header koffietafel-column-header--present">
            <v-icon
              color="#6B8E6F"
              size="22"
              class="mr-2"
            >
              mdi-check-circle-outline
            </v-icon>
            <span class="koffietafel-column-title koffietafel-column-title--present">
              Aanwezig
            </span>
          </div>
          <p class="koffietafel-column-summary">
            {{ GenodigdenTekst(DossierKoffietafelInschrijvingenAantal(true)) }} komst bevestigd.
          </p>
          <div
            v-if="aanwezig.length === 0"
            class="koffietafel-empty"
          >
            Geen aanwezigen
          </div>
          <div
            v-for="(row, index) in aanwezig"
            class="koffietafel-item"
            :key="'a-' + index"
          >
            <v-icon
              color="#6B8E6F"
              size="18"
              class="koffietafel-item-icon"
            >
              mdi-account-outline
            </v-icon>
            <div class="koffietafel-item-text">
              <span class="koffietafel-item-name">
                {{ row.volledigeNaam }}
              </span>
              <span class="koffietafel-item-count">
                {{ row.aantalPersonen }} {{ row.aantalPersonen === 1 ? 'persoon' : 'personen' }}
              </span>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Afwezig -->
      <v-col
        cols="12"
        md="5"
        lg="4"
        class="center px-2"
      >
        <div class="koffietafel-column">
          <div class="koffietafel-column-header koffietafel-column-header--absent">
            <v-icon
              color="#999"
              size="22"
              class="mr-2"
            >
              mdi-close-circle-outline
            </v-icon>
            <span class="koffietafel-column-title koffietafel-column-title--absent">
              Afwezig
            </span>
          </div>
          <p class="koffietafel-column-summary">
            {{ GenodigdenTekst(DossierKoffietafelInschrijvingenAantal(false)) }} komst afgezegd.
          </p>
          <div
            v-if="afwezig.length === 0"
            class="koffietafel-empty"
          >
            Geen afwezigen
          </div>
          <div
            v-for="(row, index) in afwezig"
            class="koffietafel-item"
            :key="'af-' + index"
          >
            <v-icon
              color="#999"
              size="18"
              class="koffietafel-item-icon"
            >
              mdi-account-outline
            </v-icon>
            <div class="koffietafel-item-text">
              <span class="koffietafel-item-name koffietafel-item-name--absent">
                {{ row.volledigeNaam }}
              </span>
              <span class="koffietafel-item-count">
                {{ row.aantalPersonen }} {{ row.aantalPersonen === 1 ? 'persoon' : 'personen' }}
              </span>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import listMixin from '@/mixins/listMixin'
import klantService from '@/services/klantService'

export default {
  name: 'KoffietafelComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    errorMixin,
    listMixin
  ],
  data () {
    return {
      aanwezig: [],
      afwezig: []
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.raadplegen = true
    klantService.Init(this)
    this.GetUitvaartKoffietafelInschrijvingList()
  },
  beforeUnmount () {
    this.$store.state.headers.raadplegen = false
  },
  methods: {
    DossierKoffietafelInschrijvingenAantal (aanwezig = null) {
      const list = aanwezig ? this.aanwezig : this.afwezig

      return list.reduce((sum, object) => {
        return sum + object.aantalPersonen
      }, 0)
    },
    DossierKoffietafelInschrijvingen (aanwezig = null) {
      return this.listMixin.list.filter(x => x.aanwezig === aanwezig)
    },
    GenodigdenTekst (number) {
      return number === 1 ? 'ene genodigde heeft zijn/haar' : `${number} genodigden hebben hun`
    },
    async GetUitvaartKoffietafelInschrijvingList () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartKoffietafelInschrijvingList()

      if (resp && (resp.data || resp.data !== '')) {
        this.listMixin.list = resp.data
        this.aanwezig = this.DossierKoffietafelInschrijvingen(true)
        this.afwezig = this.DossierKoffietafelInschrijvingen(false)
      }

      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.koffietafel-columns {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

.koffietafel-column {
  height: 100%;
}

.koffietafel-column-header {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 2px solid;
}

.koffietafel-column-header--present {
  border-color: #6B8E6F;
}

.koffietafel-column-header--absent {
  border-color: #ccc;
}

.koffietafel-column-title {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.3;
}

.koffietafel-column-title--present {
  color: #6B8E6F;
}

.koffietafel-column-title--absent {
  color: #999;
}

.koffietafel-column-summary {
  font-size: 15px;
  color: #6b6b6b;
  margin-top: 8px;
}

.koffietafel-empty {
  font-size: 15px;
  color: #bbb;
  padding: 16px 0;
  font-style: italic;
}

.koffietafel-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.koffietafel-item:hover {
  background-color: #FBF7EE;
}

.koffietafel-item-icon {
  flex-shrink: 0;
  margin-right: 12px;
}

.koffietafel-item-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.koffietafel-item-name {
  font-size: 16px;
  font-weight: 500;
  color: #424E58;
  line-height: 1.3;
}

.koffietafel-item-name--absent {
  color: #999;
}

.koffietafel-item-count {
  font-size: 14px;
  color: #999;
  line-height: 1.3;
  margin-top: 1px;
}
</style>
